import * as React from "react";
import { PropsWithChildren, useEffect, useRef, useState } from "react";

import { Resume, TagTitle } from "../../types/thecookies";
import DoNotMountComponent from "../DoNotMountComponent/DoNotMountComponent";
import Markdown from "../Markdown/Markdown";
import { createTitle } from "../shared/utils/createTitle";
import { plus_svg } from "./elements_accordion";

type PropsAccordion = PropsWithChildren<{
  resume: Resume;
  settings?: { titleTag?: TagTitle };
}>;

const Accordion: React.FC<PropsAccordion> = (props: PropsAccordion) => {
  if (!props.resume || !props.resume.title) return <DoNotMountComponent sms={"Accordion"} log={props} />;

  const mAccordion = useRef() as React.MutableRefObject<HTMLDivElement>;
  const body = useRef() as React.MutableRefObject<HTMLDivElement>;
  const [is_open, setOpen] = useState<boolean>(false);
  const title = createTitle(props.resume.title as string, props.settings?.titleTag);

  useEffect(() => {
    if (!is_open) mAccordion.current.style.setProperty("--accordion-height", `0`);
    if (is_open) {
      mAccordion.current.style.setProperty("--accordion-height", `${body.current?.children[0].clientHeight}px`);
    }
  }, [is_open]);

  const keyDownKeyBoard = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      setOpen(!is_open);
    }
  };

  const handleChildClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      ref={mAccordion}
      className={`m-accordion m-accordion${is_open ? "--open" : "--close"} `}
      onKeyDownCapture={(e) => keyDownKeyBoard(e)}
      onClick={() => {
        setOpen(!is_open);
      }}
      tabIndex={0}
    >
      <div className="accordion__headline">
        {title} {plus_svg}
      </div>
      <div ref={body} className={`accordion__body`} onClick={handleChildClick}>
        <div>
          {props.resume?.text ? <Markdown markdown={props.resume.text as string} /> : <> </>}
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
